import styles from './Desktop.module.scss';

import cx from 'classnames';
import React from 'react';

import type { IEntriesProps } from '../IEntries';
import { ItemRepeater } from '../ItemRepeater/ItemRepeater';
import { MediaWrapper } from './MediaWrapper/MediaWrapper';
import { TextWrapper } from './TextWrapper/TextWrapper';

export const Desktop: React.FC<IEntriesProps> = ({ entries, backgroundColor, className, ...props }) => {
  return (
    <section className={cx(styles.desktop, className)} {...props}>
      <div className={styles.col}>
        <ItemRepeater
          entries={entries}
          component={MediaWrapper}
          className={styles.itemWrapper}
          backgroundColor={backgroundColor}
        />
      </div>
      <div className={styles.col}>
        <ItemRepeater entries={entries} component={TextWrapper} className={styles.itemWrapper} />
      </div>
    </section>
  );
};
